import React, { useState } from 'react';
import { useSwipeable } from 'react-swipeable';
import { content } from './content';
import './App.css';

function NavButton({ screenId, setActiveScreen, activeScreen, iconClass, svgIcon }) {
  return (
    <button
      className={`button is-flex is-flex-direction-column is-justify-content-center is-align-items-center is-fullheight ${activeScreen === screenId ? 'is-active' : ''}`}
      onClick={() => setActiveScreen(screenId)}
      style={{
        flex: 1,
        borderRadius: 0,
        border: 'none',
        backgroundColor: 'transparent'
      }}
    >
      <span className={`icon is-small ${activeScreen === screenId ? 'is-active' : ''}`}>
        {!svgIcon && <i className={iconClass}></i>}
        {svgIcon && <img src="/img/barrel.svg" className={`${activeScreen === screenId ? '' : 'is-inactive'}`} />}
      </span>
    </button>
  );
}

function HomeScreen() {
  return (
    <div className="section is-flex is-align-items-center is-justify-content-center" style={{ minHeight: '100vh' }}>
      <div className="column">
        <div className="card-content has-text-centered">
          <h1><b>About the RASA Measurement Project</b></h1>
          <p>
            We measure to show it can be done, we’re the only ones who measure this way, and we measure the whole lifecycle of each barrel from cradle to recycle and beyond.
          </p>
          <button className="button  is-rounded">Contact Us</button>
        </div>
      </div>
    </div>
  );
}

function BarrelScreen() {
  const { owner, isConsumed, referenceNumber, totalFuel, totalTbds, miningLocation, miningDate, processingLocation, processingDate } = content.page.barrel;
  return (
    <div className="section is-flex is-align-items-center is-justify-content-center" style={{ minHeight: '100vh' }}>
      <div className="column">
        <div className="card-content has-text-centered">
          <p><b>This barrel belongs to</b>
            <h1><b>{owner}</b></h1></p>
          <p><b>ref </b>#{referenceNumber}</p>
        </div>
        <div className="card-image has-text-centered">
          <figure className="image is-50x50 is-inline-block">
            <img src="/img/barrel.svg" alt="barrel" />
          </figure>
          <p><b>{totalTbds.value.toFixed(1)} TBDs were used to produce this barrel</b></p>
          <p><b>{totalFuel.value.toFixed(0)} {totalFuel.units} of fuel were used to produce this barrel</b></p>
          <p>Mined from {miningLocation}, {miningDate}</p>
          <p>Processed at {processingLocation}, {processingDate}</p>
        </div>
      </div>
    </div>
  );
}

function MiningScreen() {
  const { tbdsUsed } = content.page.mining;
  return (
    <div className="section is-flex is-align-items-center is-justify-content-center">
      <div className="column">
        <div className="hero box">
          <div className="hero-body">
            <div className="card-content has-text-centered">
              <p style={{ fontSize: 200, fontWeight: 900 }}>
                {tbdsUsed.value.toFixed(0)}
              </p>
              <h2>I’m copy that describes mining in more detail</h2>
              <br />
              <p>
                Nothing too heavy, just a bit more color on where the energy is used and how it is measured - where the sensors are and what they measure etc.
              </p>
            </div>
          </div>
        </div>
        <div className="column">
          <div className="card-image has-text-centered">
            <p><b>{tbdsUsed.value.toFixed(0)} TBDs were used to mine</b></p>
            <p>I’m copy that describes the process of mining / extracting - I am brief and to the point</p>
          </div>
        </div>
      </div>
    </div >
  );
}

function TransportScreen() {
  const { tbdsUsed, distance, ore, fuel } = content.page.transport;
  return (
    <div className="section is-flex is-align-items-center is-justify-content-center">
      <div className="column">
        <div className="hero box">
          <div className="hero-body">
            <div className="card-image has-text-centered">
              <p style={{ fontSize: 200, fontWeight: 900 }}>
                {content.page.transport.tbdsUsed.value.toFixed(0)}
              </p>
            </div>
          </div>
        </div>
        <div className="column">
          <div className="card-image has-text-centered">
            <p><b>{tbdsUsed.value.toFixed(0)} TBDs were used to haul</b></p>            
            <p><b>{ore.value.toFixed(0)} {ore.units} of ore were hauled hauled {distance.value.toFixed(0)} {distance.units}</b></p>
            <p><b>{fuel.value.toFixed(0)} {fuel.units} were consumed in hauling</b></p>
            <p>I’m copy that describes the process of hauling distance, weight etc. — I am brief and to the point</p>
          </div>
        </div>
      </div>
    </div>
  );
}

function CrushingScreen() {
  const { tbdsUsed, ore, crushedOre, fuel } = content.page.crushing;
  return (
    <div className="section is-flex is-align-items-center is-justify-content-center">
      <div className="column">
        <div className="hero box">
          <div className="hero-body">
            <div className="card-image has-text-centered">
              <p style={{ fontSize: 200, fontWeight: 900 }}>
                {tbdsUsed.value.toFixed(0)}
              </p>
            </div>
          </div>
        </div>
        <div className="column">
          <div className="card-image has-text-centered">
            <p><b>{tbdsUsed.value.toFixed(0)} TBDs were used to crush</b></p>
            <p><b>{ore.value.toFixed(0)} {ore.units} of ore were crushed</b></p>
            <p><b>{crushedOre.value.toFixed(0)} {crushedOre.units} of ore were produced</b></p>
            <p><b>{fuel.value.toFixed(0)} {fuel.units} of fuel were used to crush</b></p>
            <p>I’m copy that describes the process of crushing size in / size out maybe — I am brief and to the point</p>
          </div>
        </div>
      </div>
    </div>
  );
}

function PsaScreen() {
  const { crushedOre, diesel, bitumen, sand, fuel, tbdsUsed } = content.page.psa;
  return (
    <div className="section is-flex is-align-items-center is-justify-content-center">
      <div className="column">
        <div className="hero box">
          <div className="hero-body">
            <div className="card-image has-text-centered">
              <p style={{ fontSize: 200, fontWeight: 900 }}>
                {tbdsUsed.value.toFixed(0)}
              </p>
            </div>
          </div>
        </div>
        <div className="column">
          <div className="card-image has-text-centered">
            <p><b>{tbdsUsed.value.toFixed(0)} TBDs were used to fractionate (process)</b></p>
            <p><b>{fuel.value.toFixed(0)} {fuel.units} of fuel were used</b></p>
            <p><b>{crushedOre.value.toFixed(0)} {crushedOre.units} of ore were used</b></p>
            <p><b>{diesel.value.toFixed(0)} {diesel.units} of diesel were produced</b></p>
            <p><b>{bitumen.value.toFixed(0)} {bitumen.units} of bitumen were produced</b></p>
            <p><b>{sand.value.toFixed(0)} {sand.units} of sand were produced</b></p>
            <p>I’m copy that describes what the PSA is and why it is magical — I am brief and to the point</p>
          </div>
        </div>
      </div>
    </div>
  );
}

function ProcessingScreen() {
  return (
    <div className="section is-flex is-align-items-center is-justify-content-center">
      <div className="column">
        <div className="hero box">
          <div className="hero-body">
            <div className="card-image has-text-centered">
              <p style={{ fontSize: 200, fontWeight: 900 }}>
                20
              </p>
            </div>
          </div>
        </div>
        <div className="column">
          <div className="card-image has-text-centered">
            <p><b>{content.page.processing.tbdsUsed} TBDs were used to fractionate (process)</b></p>
            I’m copy that describes the process of fractionating
            <ul>
              {content.page.processing.outputs.map((output, i) => {
                return (<li key={i}>{output.percent}% of your barrel will be used for {output.description}</li>)
              })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

function MobileLayout() {
  const [activeScreen, setActiveScreen] = useState('barrel');

  const screens = ['home', 'barrel', 'mining', 'transport', 'crushing', 'psa'];

  const renderScreen = () => {
    switch (activeScreen) {
      case 'home':
        return <HomeScreen />;
      case 'barrel':
        return <BarrelScreen />;
      case 'mining':
        return <MiningScreen />;
      case 'transport':
        return <TransportScreen />;
      case 'crushing':
        return <CrushingScreen />;
      case 'psa':
        return <PsaScreen />;
      default:
        return <BarrelScreen />;
    }
  };

  const handleSwipe = (direction) => {
    const currentIndex = screens.indexOf(activeScreen);
    if (direction === 'left' && currentIndex < screens.length - 1) {
      setActiveScreen(screens[currentIndex + 1]);
    } else if (direction === 'right' && currentIndex > 0) {
      setActiveScreen(screens[currentIndex - 1]);
    }
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => handleSwipe('left'),
    onSwipedRight: () => handleSwipe('right'),
  });

  return (
    <div className="container is-fluid px-0" style={{ minHeight: '100vh' }} {...swipeHandlers}>
      {/* Top Navigation Bar */}
      <div>
        <nav className="navbar navbar-top is-fixed-top is-link" >
          <div className="navbar-brand">
            <button className="navbar-item button is-link" onClick={() => setActiveScreen('home')}>
              <span className="icon is-small">
                <i className="fas fa-home"></i>
              </span>
            </button>
          </div>
        </nav>
      </div>

      {/* Main Content Area */}
      <main className="pb-6" style={{
        paddingBottom: 'var(--nav-height)',
        minHeight: 'calc(100vh - var(--nav-height))'
      }}>
        {renderScreen()}
      </main>

      {/* Bottom Navigation Bar */}
      <nav
        className="navbar is-fixed-bottom is-link"
        style={{
          height: 'var(--nav-height)',
          overflow: 'hidden'
        }}
      >
        <div className="navbar-menu is-active">
          <div className="navbar-item is-flex is-justify-content-space-around px-0"
            style={{ width: '100%', height: '100%' }}>
            <NavButton screenId="barrel" setActiveScreen={setActiveScreen} activeScreen={activeScreen} svgIcon="/img/barrel.svg" />
            <NavButton screenId="mining" setActiveScreen={setActiveScreen} activeScreen={activeScreen} iconClass="fas fa-hammer" />
            <NavButton screenId="transport" setActiveScreen={setActiveScreen} activeScreen={activeScreen} iconClass="fas fa-truck" />
            <NavButton screenId="crushing" setActiveScreen={setActiveScreen} activeScreen={activeScreen} iconClass="fas fa-hand-holding-droplet" />
            <NavButton screenId="psa" setActiveScreen={setActiveScreen} activeScreen={activeScreen} iconClass="fas fa-diagram-project" />
          </div>
        </div>
      </nav>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <MobileLayout />
      </header>
    </div>
  );
}

export default App;